"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "petrella-salto": {
    "db64e489": [{
      "hkey": "0819934e",
      "slug": "petrella-salto",
      "name": "Petrella Salto",
      "primary": true,
      "skipSearch": false
    }],
    "colle-rosso": [{
      "hkey": "0819934e",
      "slug": "petrella-salto",
      "name": "Petrella Salto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "33203b46": [{
      "hkey": "0819934e",
      "slug": "petrella-salto",
      "name": "Petrella Salto",
      "primary": true,
      "skipSearch": false
    }],
    "diga-salto": [{
      "hkey": "0819934e",
      "slug": "petrella-salto",
      "name": "Petrella Salto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af4f3b91": [{
      "hkey": "0819934e",
      "slug": "petrella-salto",
      "name": "Petrella Salto",
      "primary": true,
      "skipSearch": false
    }],
    "piagge": [{
      "hkey": "0819934e",
      "slug": "petrella-salto",
      "name": "Petrella Salto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;